// -----------------------------------------------------------------
cfnInputZipReg.$inject= [
  'CountryService'
];

export  function cfnInputZipReg(CountryService) {
  return {
    restrict: 'E',
    scope: {
      model: '=',
      country: '=',
      class: '@'
    },
    require: '?ngModel',
    replace: true,
    template:
        '<input ng-pattern="(zip_code_patterns[country] || zip_code_patterns.default)" maxlength="10" class="{{class}}" type="text" ng-model="model" />',
    link: function(scope, elem, attrs, ngModel) {
      scope.$watch('country', function(newVal, oldVal) {
        if (newVal != oldVal && ngModel.$viewValue) {
          ngModel.$setViewValue(ngModel.$viewValue);
        }
      });
      scope.zip_code_patterns = { default: /.*/ };
      CountryService.getCountries().then(function(response) {
        for (var x = 0; x < response.data.length; x++) {
          scope.zip_code_patterns[response.data[x].isoCode] = new RegExp(
              response.data[x].zipCodePattern,
              'i'
          );
        }
      });
    }
  };
}

